export const stopAllYouTubeVideos = () => { 
  var iframes = document.querySelectorAll('iframe');
  Array.prototype.forEach.call(iframes, iframe => { 
    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: 'command', 
        func: 'stopVideo'
      }),
      '*'
    );
  });
};
